<template>
  <v-row>
    <v-col>
      <v-snackbar
          :key="index"
          v-model="show"
          right
          top
          multi-line
          :timeout="timeout"
          vertical
          :light="$vuetify.theme.dark"
          :dark="!$vuetify.theme.dark">
        <v-row>
          <v-col cols="12" class="my-2">
            <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="-1"
                item-key="positionId"
                disable-sort-by
                dense
                hide-default-footer
                :locale="systemLocale"
                :dark="$vuetify.theme.dark">
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.positionDescription="{ item }">
                <span :title="item.positionDescription">
                  {{ item.positionDescription && item.positionDescription.length > 20
                    ? `${item.positionDescription.substring(0,20)}...`
                    : item.positionDescription }}
                </span>
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.premium="{ item }">
                {{ item.premium }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.requestedPartsCount="{ item }" dense>
                {{ item.requestedPartsCount + "/" + item.satisfiedPartsCount }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center" my-2>
            <v-btn
                text
                color="red"
                @click="close">
              {{ $t('Закрыть') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>

  import { LOT_TYPES } from '@/constants/business'

  export default {
    components: {
    },
    props: {
      index: {
        type: [Number, String],
        required: true
      },
      lotType: {
        type: String,
        required: true
      },
      order: {
        type: Object,
        required: true
      },
      timeout: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        show: true
      }
    },
    computed: {
      headers () {
        return this.lotType === LOT_TYPES.REQUEST_OFFERS_DIVISIBLE_VOLUME
          ? this.headers2
          : this.headers1
      },
      headers1 () {
        return [
          { text: this.$t('Предмет договора'), sortable: false, value: 'positionDescription' },
          { text: this.$t('Цена/дисконт'), sortable: false, value: 'premium' }
        ]
      },
      headers2 () {
        return [
          { text: this.$t('Цена 1 (одной) углеродной единицы (с учетом НДС)а'), sortable: false, value: 'premium' },
          { text: this.$t('Количество углеродных единиц\r\n(запрошено/удовлетворено)'), sortable: false, value: 'requestedPartsCount' }
        ]
      },
      items () {
        if (this.lotType === LOT_TYPES.REQUEST_OFFERS_DIVISIBLE_VOLUME) {
          return [this.order]
        }
        return this.order.premiums || []
      }
    },
    watch: {
      timeout (value) {
        if (!value || value === 0) {
          this.hide()
        }
      },
      show (value) {
        if (!value) {
          this.hide()
        }
      }
    },
    methods: {
      close: function () {
        this.$emit('close', this.index)
      },
      hide: function () {
        this.$emit('close', 0)
      }
    }
  }
</script>
